module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "m-progress-bar"
  }, [_c('div', {
    staticClass: "m-progress-bar__bar",
    style: ('width: ' + _vm.calculateWidth() + '%;' + 'background: ' + _vm.completeColor() + ';')
  })])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-458f8c54!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/ProgressBar.vue
// module id = 1668
// module chunks = 0